// extracted by mini-css-extract-plugin
module.exports = {"social":"SocialNetworks_social__1Zk7Y","socialList":"SocialNetworks_socialList__210ax"};